export type PathFlow = 'loan' | 'subscription';

export const getPathFlow = (pathname = window.location.pathname): PathFlow | null => {
  const [first] = pathname.split('/').filter(Boolean);
  return first === 'loan' || first === 'subscription' ? first : null;
};

export const clearThemeHead = () => {
  document.head.querySelectorAll('[data-theme-head]').forEach((node) => node.remove());
  delete document.documentElement.dataset.flow;
};

/** Same host key as the database lookup. Three labels or fewer keep the last two; longer hosts keep the last three. */
export const registrableHost = (hostname = window.location.hostname) => {
  if (!hostname.includes('.') || /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) {
    return hostname;
  }

  const labels = hostname.split('.');
  return labels.slice(labels.length > 3 ? -3 : -2).join('.');
};

export const fetchThemeFragment = async (href: string) => {
  try {
    const response = await fetch(href);
    if (!response.ok) {
      return '';
    }
    const text = await response.text();
    // A missing file is served as the app document.
    return /^\s*(?:<!doctype|<html)\b/i.test(text) ? '' : text;
  } catch {
    return '';
  }
};

export const applyThemeHead = (markup: string) => {
  const doc = new DOMParser().parseFromString(markup, 'text/html');

  for (const source of [...doc.head.children, ...doc.body.children]) {
    const node = document.importNode(source, true);
    node.setAttribute('data-theme-head', '');
    document.head.appendChild(node);
  }
};

export const loadThemeHead = async (host: string, flow: PathFlow | null) => {
  if (!flow) {
    return '';
  }

  return (
    (await fetchThemeFragment(`/overrides/${host}/${flow}.html`)) ||
    fetchThemeFragment(`/flow/${flow}.html`)
  );
};

export const loadThemeSheets = async (flow: PathFlow | null = getPathFlow()) => {
  if (!flow || document.head.querySelector('[data-theme-head]')) {
    return;
  }

  document.documentElement.dataset.flow = flow;
  const markup = await loadThemeHead(registrableHost(), flow);
  if (markup) {
    applyThemeHead(markup);
  }
};
